import {INVALID_TOKEN} from './actions.js';

export function invalidateToken() {
  return {
    type: INVALID_TOKEN,
  };
}
